var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.users),function(user){return _c('div',{key:user.id},[_c('User',{attrs:{"user":user}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }